
import TableGrid from './TableGrid/index';
import type { CRMFilterCondition } from '../types/grid';
import type { RecordRelatedListProps } from '../types/ui';
import { useGlobalMetadata } from '../utils/providers';

function RecordRelatedList({ tabConfig, recordId, routeName, parentRecordDeleted = false }: RecordRelatedListProps): JSX.Element {

  const { table_name, fields, schema_name } = tabConfig;
  const parentField = tabConfig.parent_field;
  const metadataInfo = useGlobalMetadata();
  const metadata = metadataInfo?.data;
  
  
  if (!table_name) {
    return <div>Error: No table specified for related list</div>;
  }
  
  if (!parentField) {
    return <div>Error: No parent field specified for related list</div>;
  }
  
  // tabConfig.gridPath = `related-list-${table_name}-${parentField}`;
  
  // Determine the foreign key field dynamically or adjust as needed
  const gridFilter: Record<string, CRMFilterCondition> = {
    [parentField]: {
      filterType: 'number',
      type: 'equals',
      filter: recordId,
    },
  };

  // Transform fields to match GridConfiguration interface requirements
  const transformedFields = fields?.map(field => {
    const dbCol = metadata?.fieldData?.[table_name]?.byFieldName?.[field.field];
    if (!dbCol) {
      // Create a minimal EnrichedTableField structure for missing fields
      return {
        field: field.field,
        dbCol: {
          field_name: field.field,
          data_type: 'text',
          is_nullable: true,
          is_system: false,
          is_calculated: false,
          ui_label: field.field
        } as any
      };
    }
    return {
      field: field.field,
      dbCol
    };
  }) || [];

  const gridConfig = {
    name: `related-list-${table_name}-${parentField}`,
    table_name,
    schema_name,
    ui_data: {
      ...tabConfig,
      schema_name,
      fields: transformedFields,
      parentRecordDeleted
    }
  };
  return (
    <TableGrid
      routeName={routeName}
      gridConfig={gridConfig}
      topLevelFilters={gridFilter}
      readOnly={parentRecordDeleted}
    />
  );
}

export default RecordRelatedList;